import { Divider, Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Stars01FilledIcon } from '@/components/icons/Stars01FilledIcon';
import { COLORS } from '@/styles/tokens/colors';

import { useHouseholdChatContext } from '../contexts/householdChat.context';
import { useHasHouseholdChat } from '../hooks/useHasHouseholdChat';

/**
 * App-bar toggle for the docked household chat sidebar. Renders nothing
 * unless the tenant has AI capabilities enabled. Must be rendered inside
 * HouseholdChatProvider.
 *
 * Also renders the divider that separates the chat entry point from the
 * global app-bar buttons, so the divider only appears when the button does.
 */
export function HouseholdChatToggleButton() {
  const { closeChat, isChatOpen, openChat } = useHouseholdChatContext();
  const hasHouseholdChat = useHasHouseholdChat();

  if (!hasHouseholdChat) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center">
      <Button
        data-testid="household-chat-toggle-button"
        variant="prominent"
        size="xs"
        startIcon={Stars01FilledIcon}
        // The filled stars fill via currentColor, so set color (not fill) to
        // keep them solid white. The explicit size matches the button's
        // default icon size for size="xs".
        iconProps={{ size: 16, color: COLORS.PRIMITIVES.WHITE }}
        onClick={isChatOpen ? closeChat : openChat}
        sx={{ whiteSpace: 'nowrap' }}
      >
        Ask Luminary AI
      </Button>
      <Divider orientation="vertical" sx={{ mx: 3, height: '24px' }} />
    </Stack>
  );
}
